var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:{
    'tabs-title': true,
    'is-active': _vm.active,
  }},[_c('a',{staticClass:"flex flex-row items-center cursor-pointer py-1.5",on:{"click":_vm.onTabClick}},[(_vm.icon)?_c('span',{style:({ marginRight: '0.4rem' })},[_c('fluent-icon',_vm._b({attrs:{"icon":_vm.icon}},'fluent-icon',_vm.iconProps,false))],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.name)+" ")]),_vm._v(" "),(_vm.showBadge)?_c('div',{staticClass:"badge min-w-[20px]"},[_c('span',[_vm._v("\n        "+_vm._s(_vm.getItemCount)+"\n      ")])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }